import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	feedbackButtonLabel: {
		id: 'software.main.header.feedback-collector-button.feedback-button-label',
		defaultMessage: 'Give feedback',
		description: 'Label for button to give feedback',
	},
});
